export default __webpack_public_path__ + "static/media/Die_3.d133512f.png";